<!--
省市区联动组件
父页面：
 <region :regionInfo="regionInfo" @returnRegion="returnRegion" ref="callRegion"></region>
 // 由于每个页面获取的省市区参数可能不一致 ，这里直接定义一个regionInfo接收及赋值
  regionInfo: {
        provinceId: '',
        cityId: '',
        areaId: '',
      }
  // 初始化
  this.$refs.callRegion.initRegion()()
-->
<template>
  <el-row :gutter="5"  v-if="isHaveArea">
    <el-col :span="8">
      <el-select v-model="provinceId" @change="selectProvince" :disabled="disabled" :placeholder="placeholder" clearable>
        <el-option v-for="(item, index) in provinceList" :key="index" :value="item.code" :label="item.regionName" />
      </el-select>
    </el-col>
    <el-col :span="8">
      <el-select v-model="cityId" @change="selectCity" :disabled="disabled" :placeholder="placeholder" clearable>
        <el-option v-for="item in cityList" :key="item.code" :value="item.code" :label="item.regionName" />
      </el-select>
    </el-col>
    <el-col :span="7">
      <el-select v-model="areaId" @change="selectArea" :disabled="disabled" :placeholder="placeholder" clearable>
        <el-option v-for="item in areaList" :key="item.code" :value="item.code" :label="item.regionName" />
      </el-select>
    </el-col>
  </el-row>
  <el-row :gutter="5" v-else>
    <el-col :span="12">
      <el-select v-model="provinceId" @change="selectProvince" :disabled="disabled" :placeholder="placeholder" clearable>
        <el-option v-for="(item, index) in provinceList" :key="index" :value="item.code" :label="item.regionName" />
      </el-select>
    </el-col>
    <el-col :span="11">
      <el-select v-model="cityId" @change="selectCity" :disabled="disabled" :placeholder="placeholder" clearable>
        <el-option v-for="item in cityList" :key="item.code" :value="item.code" :label="item.regionName" />
      </el-select>
    </el-col>
  </el-row>
</template>
<script>
export default {
  name: 'region',
  props: {
    regionInfo: { // 地区初始化信息
      type: Object,
      default: () => {}
    },
    disabled: { // 是否禁用
      type: Boolean,
      default: false
    },
    placeholder: { // 默认提示
      type: String,
      default: '请选择'
    },
    isHaveArea: { // 是否包含区县选择框
      type: Boolean,
      default: true
    },
    operateId: { // 操作id，用来当页面出现多个地区选择框时区分之用
      type: String,
      default: ''
    },
    needChangeSort: { // 是否需要改变省数组的排序
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      api: this.$API.common.region,
      provinceList: [],
      cityList: [],
      areaList: [],
      provinceId: '',
      cityId: '',
      areaId: '',
      provinceName: '',
      cityName: '',
      areaName: '',
      headerProvinceList: ['广西', '云南', '广东', '海南', '新疆', '辽宁', '山东', '河北', '福建', '江苏'] // 需放在列表前面的省份
    }
  },
  watch: {
    // 父组件地区信息更新的时候，重新初始化
    regionInfo: {
      handler () {
        this.initRegion()()
      },
      deep: true
    }
  },
  created () {
    this.initRegion()() // 初始化信息
  },
  methods: {
    // 初始化
    initRegion () {
      return async () => {
        this.provinceId = this.regionInfo.provinceId
        this.cityId = this.regionInfo.cityId
        this.areaId = this.regionInfo.areaId
        this.cityList = this.provinceId ? await this.getRegion(this.provinceId) : []
        this.areaList = this.cityId ? await this.getRegion(this.cityId) : []
        // 如果需要排序，就调用排序方法，否则，获取初始数据即可
        if (this.needChangeSort) {
          this.getSortProvinceList()
        } else {
          this.provinceList = await this.getRegion(1)
        }
      }
    },
    // 获取排序的省数组，将10个特定的省份按照一定顺序排到数组头部
    getSortProvinceList () {
      const param = { parentCode: 1 }
      this.$http.post(this.api.retrieve, param).then(res => {
        let headerList = [] // 头部数组，用来存放要排序的10个省份
        let lastList = [] // 用来存放不用排序其它省份
        res.data.map((item) => {
          if (this.headerProvinceList.includes(item.regionName)) { // 判断是否是需要排序的省份
            let positionIndex = this.headerProvinceList.indexOf(item.regionName) // 找出对应的位置
            headerList[positionIndex] = item // 按照设定的位置将相应的省份插入到头部数组中
          } else {
            lastList.push(item) // 不需要排序的数组添加到另个数组即可
          }
        })
        this.provinceList = [...headerList, ...lastList] // 两个数组拼接起来即可
      })
    },
    // 获取区域信息
    getRegion (id) {
      const param = { parentCode: id }
      return new Promise((resolve, reject) => {
        this.$http.post(this.api.retrieve, param).then(res => {
          resolve(res.data)
        })
      })
    },
    // 选择省
    selectProvince (val) {
      this.provinceId = val
      this.provinceName = this.getName(this.provinceList, this.provinceId, this.provinceName)
      this.cityList = []
      if (this.provinceId) {
        this.getRegion(this.provinceId).then(result => { // 根据选择的省，获取下属市的信息
          this.cityList = result
        })
      }
      this.selectCity()
      if (this.isHaveArea) {
        this.selectArea()
      }
    },
    // 选择市
    selectCity (val) {
      this.cityId = val
      this.cityName = this.getName(this.cityList, this.cityId, this.cityName)
      // 这是处理当初始化的时候有传省市ID进来，然后直接改了市，这时候就需要把省的名称也获取一下，要不然返回的省名称为空
      if (this.provinceId && !this.provinceName) {
        this.provinceName = this.getName(this.provinceList, this.provinceId, this.provinceName)
      }
      if (this.isHaveArea) {
        this.areaList = []
        if (this.cityId) {
          this.getRegion(this.cityId).then(result => { // 根据选择的市，获取下属的区县的信息
            this.areaList = result
          })
        }
        this.selectArea()
      } else {
        this.$emit('returnRegion', { // 如果组件是不要求区县的，这里就可以把选择的信息直接返回了
          operateId: this.operateId,
          provinceId: this.provinceId,
          cityId: this.cityId,
          provinceName: this.provinceName,
          cityName: this.cityName
        })
      }
    },
    // 选择区县
    selectArea (val) {
      this.areaId = val
      this.areaName = this.getName(this.areaList, this.areaId, this.areaName)
      if (this.cityId && !this.cityName) {
        this.cityName = this.getName(this.cityList, this.cityId, this.cityName)
      }
      if (this.provinceId && !this.provinceName) {
        this.provinceName = this.getName(this.provinceList, this.provinceId, this.provinceName)
      }
      this.$emit('returnRegion', {
        operateId: this.operateId,
        provinceId: this.provinceId,
        cityId: this.cityId,
        areaId: this.areaId,
        provinceName: this.provinceName,
        cityName: this.cityName,
        areaName: this.areaName
      })
    },
    getName (list, id, name) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].code === id) {
          return list[i].regionName
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
